import Service from "../Service";

const resource = "approvaltrigger/";

export default {
  save(atg, requestID) {
    return Service.post(resource + "save", atg, {
      params: { requestID: requestID },
    });
  },
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },  
};